import { render, staticRenderFns } from "./BFooter.vue?vue&type=template&id=5a3e3cf0&"
import script from "./BFooter.vue?vue&type=script&lang=js&"
export * from "./BFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports